/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Bright_Moth_HowlInputs */

const en_wry_bright_moth_howl = /** @type {(inputs: Wry_Bright_Moth_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No role configured. Login won't be possible.`)
};

const de_wry_bright_moth_howl = /** @type {(inputs: Wry_Bright_Moth_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Rolle gesetzt. Login nicht möglich.`)
};

/**
* | output |
* | --- |
* | "No role configured. Login won't be possible." |
*
* @param {Wry_Bright_Moth_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_bright_moth_howl = /** @type {((inputs?: Wry_Bright_Moth_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Bright_Moth_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_bright_moth_howl(inputs)
	return de_wry_bright_moth_howl(inputs)
});